import { render } from "./GeneralMSI.vue?vue&type=template&id=f5564a20&scoped=true"
import script from "./GeneralMSI.vue?vue&type=script&lang=js"
export * from "./GeneralMSI.vue?vue&type=script&lang=js"

import "./GeneralMSI.vue?vue&type=style&index=0&id=f5564a20&scoped=true&lang=css"

import exportComponent from "/var/www/adm3.argusblack/adm3.argusblack/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f5564a20"]])

export default __exports__